import { render, staticRenderFns } from "./TestAssessor.vue?vue&type=template&id=5b0b45e6&"
import script from "./TestAssessor.vue?vue&type=script&lang=js&"
export * from "./TestAssessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports